import ElementTemplate from '../ElementTemplate';

export interface PriceItemData {
  cssClass: string;
  closeBtnText: string;
  signUpBtnText: string;
  itemPriceFrom: string;
  itemPriceTo: string;
  categoryTitle: string;
  soon: string;
  items: {
    title?: string;
    subTitle?: string;
    itemText?: string;
    itemPriceRsd1?: string;
    itemPriceRsd2?: string;
    itemPriceEur1?: string;
    itemPriceEur2?: string;
  }[];
}
export class PriceItemElement extends ElementTemplate {
  // closeBtn!: ElementTemplate<HTMLButtonElement>;
  isMobile: boolean;

  constructor(priceData: PriceItemData, isMobile: boolean) {
    super(null, 'div', priceData.cssClass);
    this.isMobile = isMobile;
    this.setupPriceItem(priceData);
  }

  setupPriceItem = (priceData: PriceItemData) => {
    const { categoryTitle, items } = priceData;

    let content = `
      <h3 class="price__item-title">${categoryTitle}</h3>
    `;

    items.forEach((item) => {
      const rsd = item.itemPriceRsd1 !== priceData.soon ? 'RSD' : '';
      const eur = item.itemPriceRsd1 !== priceData.soon ? '€' : '';
      content += `
        <h4 class="price__item-service-title">${item.title}</h4>
        <div class="price__item-service-subtitle">${item.subTitle}</div>
        <p class="price__item-text">${item.itemText}</p>
        <div class="price__item-price-rsd">${item.itemPriceRsd2 ? priceData.itemPriceFrom : ''} <span class="price__item-price-rsd-digit">${item.itemPriceRsd1}</span> <span class="price__item-price-rsd-rsd">${rsd}</span>${item.itemPriceRsd2 ? '/ ' + priceData.itemPriceTo : ''} ${item.itemPriceRsd2}</div>
        <div class="price__item-price-eur">${item.itemPriceEur1}${eur}${item.itemPriceEur2 ? '/ ' + item.itemPriceEur2 + '€' : ''}</div>
      `;
    });
    if (this.isMobile) {
      content += `
        <div class="price__item-btn-container">
          <button type="button" class="price__item-close-btn">
            <svg class="price__item__close-btn-svg" width="8" height="24">
              <use href="../assets/svg/sprite.svg#close-price-arrow" x="0" y="0"></use>
            </svg>
            <span class="price__item__close-text">${priceData.closeBtnText}</span>
          </button>
          <button type="button" class="price__item__btn btn btn_dark btn_contact" title="${priceData.signUpBtnText}">${priceData.signUpBtnText}</button>
        </div>
      `;
    }
    this.node.innerHTML = content;
  };

  // createCloseBtn = () => {
  //   const btnContainer = new ElementTemplate(this.node, 'div', 'price__item-btn-container');

  //   this.closeBtn = new ElementTemplate<HTMLButtonElement>(btnContainer.node, 'button', 'price__item-close-btn');
  //   this.closeBtn.node.type = 'button';
  //   this.closeBtn.node.innerHTML = `
  //     <span class="price__item__close-text">свернуть</span>
  //     <svg class="price__item__close-btn-svg" width="8" height="24">
  //       <use href="assets/svg/sprite.svg#close-price-arrow" x="0" y="0"></use>
  //     </svg>
  //   `;

  //   const signUpBtn = new ElementTemplate<HTMLAnchorElement>(btnContainer.node, 'a', 'price__item__btn btn btn_dark');
  //   signUpBtn.node.href = '#pricing-approach';
  //   signUpBtn.node.title = 'Записаться';
  //   signUpBtn.node.textContent = 'Записаться';
  // };

  // addListeners = () => {
  //   this.closeBtn.node.addEventListener('click', () => {
  //     this.node.classList.remove('active');
  //   });
  // };
}
